<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.sc_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="sc_date">
            <label class="weui-form-preview__label">{{customLabel.sc_date || "日期"}}</label>
            <em class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.sc_date}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_custname">
            <label class="weui-form-preview__label">{{customLabel.sc_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_custname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_address">
            <label class="weui-form-preview__label">{{customLabel.sc_address || "客户地址"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_address}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_contact">
            <label class="weui-form-preview__label">{{customLabel.sc_contact || "联系人"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_contact}} <call-mobile :mobile="form.main.sc_tel"></call-mobile></em>
          </div>
          <div class="weui-form-preview__item" slot="sc_payments">
            <label class="weui-form-preview__label">{{customLabel.sc_payments || "收费方式"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_payments}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_day">
            <label class="weui-form-preview__label">{{customLabel.sc_day || "结算日"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_day}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_currency">
            <label class="weui-form-preview__label">{{customLabel.sc_currency || "币种"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_currency}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_rate">
            <label class="weui-form-preview__label">{{customLabel.sc_taxrate || "税率"}}</label>
            <em class="weui-form-preview__value">{{form.main.sc_taxrate}} %</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_amount">
            <label class="weui-form-preview__label">{{customLabel.sc_amount || "合同金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(form.main.sc_amount,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sc_feeamount">
            <label class="weui-form-preview__label">{{customLabel.sc_feeamount || "每次收费金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(form.main.sc_feeamount,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sc_startdate">
            <label class="weui-form-preview__label">{{customLabel.sc_startdate || "生效日期"}}</label>
            <em class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.sc_startdate}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sc_enddate">
            <label class="weui-form-preview__label">{{customLabel.sc_enddate || "截止日期"}}</label>
            <em class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.sc_enddate}}</em>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.scd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="scd_siname">
              <label class="weui-form-preview__label">{{customLabel.scd_siname || "项目名称"}}</label>
              <span
                class="weui-form-preview__value"
              >{{item.scd_siname}}</span>
            </div>
            <div class="weui-form-preview__item" slot="si_spec">
              <label class="weui-form-preview__label">{{customLabel.si_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.si_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="scd_qty">
              <label class="weui-form-preview__label">{{customLabel.scd_qty || "数量"}}</label>
              <span class="weui-form-preview__value">{{item.scd_qty}} {{item.si_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="scd_price">
              <label class="weui-form-preview__label">{{customLabel.scd_price || "含税单价"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.scd_price,'#,##0.####')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="scd_amount">
              <label class="weui-form-preview__label">{{customLabel.scd_amount || "金额"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.scd_amount,'#,##0.####')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="scd_remark">
              <label class="weui-form-preview__label">{{customLabel.scd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{item.scd_remark}}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <file-list v-model="form.main.sc_attach"></file-list>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <router-link
        :to="'/crm/serve_contract_edit?id=' + form.main.id"
        v-if="form.main.sc_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="form.main.sc_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="form.main.sc_status == '已审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="form.main.sc_status == '未审核'"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import Collapse from "@/components/Collapse.vue";
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CallMobile,
    Collapse,
    FileList
  },
  data() {
    return {
      baseUrl: "/api/sale/servecontract",
      codeField: "sc_code",
      caller: "ServeContract",
      xtype: "make-servecontract-formpanel",
    };
  },
  methods: {
    p_remove() {
      const me = this

      me.$weui.confirm('确定删除单据？', function () {
        me.$loading({
          url: `/api/sale/servecontract/delete/${me.form.main.id}?caller=ServeContract`,
          method: "POST"
        }).then(res => {
          if(res.success) {
            me.$router.back()
          }
        })
      });
    }
  }
};
</script>